import React from "react";
import { Receipt, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import DashboardAvatar from "./DashboardAvatar";
import { convertToIndianCurrency } from "../../utils/common";

function formatDate(d) {
  if (!d) return "";
  return new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", timeZone: "Asia/Kolkata" });
}

const RecentPayments = ({ payments = [] }) => {
  const navigate = useNavigate();
  return (
    <div className="db-card">
      <div className="db-card-head">
        <div className="db-card-head-left">
          <div className="db-card-icon emerald"><Receipt size={18} /></div>
          <div>
            <div className="db-card-title">Recent Payments</div>
            <div className="db-card-subtitle">Latest transactions</div>
          </div>
        </div>
        <button className="db-card-link" onClick={() => navigate("/fees")}>
          View All <ArrowRight size={12} />
        </button>
      </div>
      <div className="db-card-body">
        {payments.map((p, idx) => (
          <div key={p._id || idx} className="db-list-item">
            <DashboardAvatar name={p.studentId?.name} />
            <div className="db-list-info">
              <div className="db-list-name">{p.studentId?.name || "—"}</div>
              <div className="db-list-sub">{formatDate(p.date)}</div>
            </div>
            <span className="db-list-value-green">
              {convertToIndianCurrency(p.currentPayment)}
            </span>
          </div>
        ))}
        {payments.length === 0 && <div className="text-muted text-center py-3" style={{ fontSize: "0.8125rem" }}>No recent payments</div>}
      </div>
    </div>
  );
};

export default RecentPayments;
